/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ErrorEvent,
  SpanJSON,
  Breadcrumb,
  TransactionEvent,
} from '@sentry/core'

const REDACTED_KEY = 'REDACTED'

const redactKey = (value: string) => {
  return value.replace(/([?&]key=)[^&]+/, (_match, prefix) => {
    return prefix + REDACTED_KEY
  })
}

export const sentryBeforeSendScrubber = (event: ErrorEvent) => {
  if (event.request?.url && event.request.url.includes('key')) {
    event.request.url = redactKey(event.request.url)
  }
  return event
}

export const sentryBeforeBreadcrumbScrubber = (breadcrumb: Breadcrumb) => {
  if (breadcrumb.category === 'navigation') {
    if (breadcrumb.data?.from.includes('key')) {
      breadcrumb.data.from = redactKey(breadcrumb.data.from)
    }
    if (breadcrumb.data?.to.includes('key')) {
      breadcrumb.data.to = redactKey(breadcrumb.data.to)
    }
  }
  if (breadcrumb.category === 'console') {
    if (breadcrumb.data?.arguments && breadcrumb.data?.arguments.length > 0) {
      breadcrumb.data.arguments = breadcrumb.data.arguments.map(
        (arg: unknown) => {
          if (typeof arg === 'string' && arg.includes('key')) {
            return redactKey(arg)
          }
          return arg
        }
      )
    }
    if (breadcrumb?.message && breadcrumb?.message.includes('key')) {
      breadcrumb.message = redactKey(breadcrumb.message)
    }
  }
  return breadcrumb
}

export const sentryBeforeSendSpanScrubber = (span: SpanJSON) => {
  if (span) {
    Object.keys(span).forEach((key) => {
      if (key === 'data') {
        const data = span.data as Record<string, unknown>
        Object.keys(data).forEach((dataKey) => {
          const dataValue = data[dataKey]
          if (
            dataValue &&
            typeof dataValue === 'string' &&
            dataValue.includes('key')
          ) {
            data[dataKey] = redactKey(dataValue)
          }
        })
      } else {
        const value = span[key as keyof SpanJSON]
        if (value && typeof value === 'string' && value.includes('key')) {
          ;(span as any)[key] = redactKey(value)
        }
      }
    })
  }

  return span
}

export const sentryBeforeSendTransactionScrubber = (
  transaction: TransactionEvent
) => {
  if (transaction.request?.url && transaction.request.url.includes('key')) {
    transaction.request.url = redactKey(transaction.request.url)
  }
  return transaction
}
